import type { RendererProps } from "../core/element-registry"
import { ElementRenderer } from "./element-renderer"
import { Card, CardContent } from "../components/ui/card"
import { cn } from "../lib/utils"
import { spacingToken } from "../lib/design-tokens"

export function CardRenderer({ element }: RendererProps) {
  const containerVariant = element.variant ?? ""

  const variantClasses: Record<string, string> = {
    card: "overflow-hidden transition-shadow hover:shadow-lg",
    default: "",
  }

  return (
    <Card className={cn(variantClasses[containerVariant] ?? "", element.className)}>
      <CardContent className={cn(element.padding ? `p-${spacingToken(element.padding)}` : "p-6 pt-0")}>
        {element.children?.map((child) => (
          <ElementRenderer key={child.id} element={child} />
        ))}
      </CardContent>
    </Card>
  )
}
